module.exports = __webpack_public_path__ + "static/fonts/dfyuanstd-w7.088c336.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/dfyuanstd-w7.otf
// module id = MROa
// module chunks = 1